import React, { useEffect } from "react";
import AOS from "aos";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./HomePage.css";

import PlaceCard from "../../components/Place/Place";
import ArticleCard from "../../components/Article/Article";

import data from "../../data/index.json";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { EffectCoverflow, Pagination, Navigation } from "swiper/modules";

import ContactForm from "../../components/Contact/ContactForm";
import WhatsAppIcon from "../../components/WhatsAppIcon/WhatsAppIcon";

function HomePage() {
  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
    ],
  };

  const settingsArticle = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: Math.min(data.home.articles.length, 4),
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: Math.min(data.home.articles.length, 3),
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
    ],
  };

  return (
    <div className="overlay-background">
      <div className="home-page">
        <div className="hero-home">
          <div className="hero-home-content">
            <h1 className="hero-text-home" data-aos="fade-up">
              <span className="block-text">
                {data.siteContent.homepage.hero.title}
              </span>
            </h1>
            <p className="hero-para" data-aos="fade-up">
              {data.siteContent.homepage.hero.subtitle}
            </p>
          </div>
        </div>
        <div className="our-story-section">
          <div className="our-story">
            <div className="section-content-wrapper">
              <h2 className="section-title">{data.siteContent.homepage.sections.ourStory.title}</h2>

              <div className="our-story-content-wrapper">
                <p className="our-story-content" data-aos="fade-up">
                  {data.siteContent.homepage.sections.ourStory.content}
                </p>
                <div className="img-container" data-aos="fade-up">
                  <img
                    src={data.siteContent.homepage.sections.ourStory.image}
                    className="our-story-collage"
                    alt="our_story_collage"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="discover-us">
          <div className="section-content-wrapper">
            <h2 className="section-title-discover-us">{data.siteContent.homepage.sections.discoverUs.title}</h2>
            <div className="places-carousel">
              <Slider {...settings} className="places-slider">
                {data.home.places.map((place) => {
                  return (
                    <PlaceCard
                      className="place-card"
                      key={place.id}
                      props={{
                        image: place.image,
                        place_title: place.place_title,
                        place_address: place.place_address,
                        place_phone: place.place_phone,
                      }}
                    />
                  );
                })}
              </Slider>
            </div>
          </div>
        </div>
        <div className="our-products-section">
          <div className="our-products">
            <div className="section-content-wrapper">
              <h2 className="section-title">{data.siteContent.homepage.sections.ourProducts.title}</h2>
              <div className="product-image-carousel" data-aos="fade-up">
                <Swiper
                  effect={"coverflow"}
                  grabCursor={true}
                  centeredSlides={true}
                  loop={true}
                  slidesPerView={4}
                  coverflowEffect={{
                    rotate: 0,
                    stretch: 0,
                    depth: 100,
                    modifier: 2.5,
                  }}
                  pagination={{ el: ".swiper-pagination", clickable: true }}
                  navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                    clickable: true,
                  }}
                  modules={[EffectCoverflow, Pagination, Navigation]}
                  className="swiper-container"
                >
                  {data.home.products.map((product) => {
                    return (
                      <SwiperSlide>
                        <img
                          src={product.image}
                          className="product-img"
                          alt={product.alt}
                        />
                      </SwiperSlide>
                    );
                  })}
                  <div className="slider-controler">
                    <div className="swiper-button-prev slider-arrow">
                      <ion-icon name="arrow-back-outline"></ion-icon>
                    </div>
                    <div className="swiper-button-next slider-arrow">
                      <ion-icon name="arrow-forward-outline"></ion-icon>
                    </div>
                    <div className="swiper-pagination"></div>
                  </div>
                </Swiper>
              </div>
              <a
                className="more-details-button"
                data-aos="fade-up"
                href="/our-products"
              >
{data.siteContent.homepage.sections.ourProducts.buttonText}
              </a>
            </div>
          </div>
        </div>
        <div className="featured-articles">
          <div className="section-content-wrapper">
            <h2 className="section-title">{data.siteContent.homepage.sections.featuredArticles.title}</h2>
            <div className="articles-carousel">
              <Slider {...settingsArticle} className="articles-slider">
                {data.home.articles
                  .slice()
                  .reverse()
                  .map((article) => {
                    return (
                      <ArticleCard
                        className="article-card"
                        key={article.id}
                        props={{
                          image: article.image,
                          article_title: article.article_title,
                          article_content: article.article_content,
                        }}
                      />
                    );
                  })}
              </Slider>
            </div>
          </div>
        </div>

        <ContactForm />
        <div className="bottom"></div>
        <WhatsAppIcon />
      </div>
    </div>
  );
}

export default HomePage;
